<template>
  <form @submit.prevent="transferToParent" :disabled="loading">
    <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{translate('customTargetSystem.createCustomTarget')}}</h5>
            <button type="button" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="height:500px; overflow-y: auto;">
              <div class="col-12">
                <div class="form-group row">
                  <label class="col-form-label col-sm-3">{{translate('customTargetSystem.targetName')}}</label>
                  <div class="col-sm-9">
                    <input v-model="data.Name" @input="checkInput('Name',$event)" type="text" class="form-control" required />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-form-label col-sm-3">{{translate('customTargetSystem.targetKind')}}</label>
                  <div class="col-sm-9">
                    <select v-model="data.Kind" class="form-control" required>
                      <option value="Email">{{translate('customTargetSystem.email')}}</option>
                      <option value="Rem" v-if="hasModule('REM')">{{translate('customTargetSystem.kep')}}</option>
                    </select>
                  </div>
                </div>
                <component v-bind:is="data.Kind" v-model="data"></component>
              </div> 
          </div>
          <div class="modal-footer footer-button-container"> 
            <button type="button"  class="btn btn-secondary" @click="close()" data-dismiss="modal">
              {{translate('close')}}
            </button>
            <button type="submit"  class="btn btn-primary">
              {{translate('save')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import formMixin from "../formMixin.js";
import formContainer from "../components/FormContainer.vue";
import Email from "../components/TargetSystem/Email.vue";
import Rem from "../components/TargetSystem/Rem.vue";

export default {
    mixins: [formMixin],
    components: {
        formContainer,
        Email,
        Rem,
    },
    created() {
        if(!this.model.Kind)
          this.model.Kind = "Email";

        this.data = Object.assign({}, this.model);
    }, 
    props: {
          value : Object,
          model: Object,
      },
    data() {
        return {
            loading: false, 
            data: {}
        };
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
        transferToParent(){
            if(!this.data.To || this.data.To.length == 0) {
              alert(this.translate('errors.atLeastOneEmail'));
            } else {
              this.$emit("onsave", this.data);  
            }
        },
        close(){
            this.$emit('close');
        }
    },
};
</script>
